<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="esgProfil">
                <pr-input-radio
                  formControlName="includeNonESG"
                  columns="3"
                  [toggle]="true"
                  [isDefault]="false"
                  label="Souhaitez-vous écarter des activités ayant des impacts environnementaux et/ou sociaux négatifs de votre investissement ?"
                >
                </pr-input-radio>
                @if (owner?.get('esgProfil')?.get('includeNonESG')?.value) {
                  <ng-template #default></ng-template>
                  <div class="row">
                    <div class="col-md-12">
                      <span class="pr-input-label ng-star-inserted"
                        >Sur quel(s) critère(s) souhaitez-vous minimiser vos
                        impacts négatifs ?
                      </span>
                    </div>
                    <div class="col-md-12">
                      <div class="checkbox">
                        <pr-checkbox-group
                          formControlName="nonESGInvestments"
                          [template]="default"
                          [options]="nonESGInvestmentsOptions"
                        >
                        </pr-checkbox-group>
                      </div>
                    </div>
                  </div>
                }
                <div class="row mt">
                  <div class="col-md-12">
                    <span class="pr-input-label ng-star-inserted"
                      >Je souhaite éviter d'investir dans les activités
                      suivantes
                    </span>
                  </div>
                  <div class="col-md-12">
                    <div class="checkbox">
                      <pr-checkbox-group
                        formControlName="investmentsForbiden"
                        [template]="default"
                        [options]="investmentsForbidenOptions"
                      >
                      </pr-checkbox-group>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
